import React, { memo } from 'react'
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
// Local files
import useCustomSelector from 'hooks/useCustomSelector';
import useError from 'hooks/useError';
import { errorSelectors } from 'features/error';

const ErrorSnackbar = () => {
  const { hideError } = useError();
  const { open, message } = useCustomSelector(errorSelectors.getError);

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      open={open}
      autoHideDuration={5000}
      onClose={hideError}
    >
      <Alert
        icon={false}
        onClose={hideError}
        sx={{
          color: '#fff',
          backgroundColor: 'error.main',
          borderRadius: '2px',
          fontSize: '0.75rem'
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default memo(ErrorSnackbar);